import { FileUploader } from 'features/files'
import { useGeckoNotifications } from 'features/notifications'
import { FC, useCallback, useMemo } from 'react'

import { NiiViewContainer } from './components/NiiViewContainer'
import { NiiViewProps } from './NiiDetailsModal'

export const NiiFileUploadView: FC<NiiViewProps> = ({ unitEntry }) => {
  const { successNotification, errorNotification } = useGeckoNotifications()

  const tags: Record<string, string> = useMemo(() => {
    const baseTags: Record<string, string> = { unit: unitEntry.id }

    if (unitEntry.tags.organization) {
      baseTags.organization = unitEntry.tags.organization
    }

    if (unitEntry.tags.site) {
      baseTags.site = unitEntry.tags.site
    }

    return baseTags
  }, [unitEntry.id, unitEntry.tags.organization, unitEntry.tags.site])

  const handleUploadComplete = useCallback(() => {
    successNotification('Files uploaded successfully')
  }, [successNotification])

  const handleUploadError = useCallback(
    (error: string) => {
      console.error('Upload failed:', error)
      errorNotification('Upload failed')
    },
    [errorNotification]
  )

  return (
    <NiiViewContainer
      title='Upload Supporting Documents'
      description='Upload files related to this NII assessment. These documents will be associated with the asset and organization and can include inspection reports, technical specifications, photographs, or any other relevant documentation.'>
      <FileUploader
        tags={tags}
        onUploadComplete={handleUploadComplete}
        onUploadError={handleUploadError}
        acceptedFileTypes={['*/*']}
        multiple={true}
        entry={unitEntry}
        showExistingFiles={true}
      />
    </NiiViewContainer>
  )
}
